// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"648b0dce","553":"777c874a"}[chunkId] + ".chunk.js";
};